(() => {
  let observer;
  const root = document.documentElement;
  function measure() {
    const header = document.querySelector('.section-header sticky-header .jss-header');
    const sticky = header?.closest('sticky-header');
    const always = ['always', 'reduce-logo-size'].includes(sticky?.dataset.stickyType);
    const height = always ? Math.ceil(header.getBoundingClientRect().height) : 0;
    root.style.setProperty('--jss-sticky-header-height', `${height}px`);
  }
  function connect() {
    observer?.disconnect();
    const header = document.querySelector('.section-header sticky-header .jss-header');
    if (header && 'ResizeObserver' in window) {
      observer = new ResizeObserver(measure);
      observer.observe(header);
    }
    measure();
  }
  connect();
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('pageshow', measure);
  document.addEventListener('shopify:section:load', connect);
  document.addEventListener('shopify:section:unload', connect);
  document.fonts?.ready.then(measure);
})();
